var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full h-full",staticStyle:{"display":"flex","align-items":"center","justify-content":"center"}},[_c('v-progress-circular',{attrs:{"color":"subtitlecolor","indeterminate":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }